module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "messageDelete",
    attrs: {
      "title": "删除",
      "visible": _vm.dialogFormVisible,
      "top": "20%",
      "width": "460px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("是否确认删除此条信息，是否继续？")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("下次删除操作不再提示")]), _vm._v(" "), _c('div', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.submitForm('cancel')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('true')
      }
    }
  }, [_vm._v("确认")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b6bc5f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/message/delete-message.vue
// module id = 1242
// module chunks = 82